// Whitelist of trusted domains for video content
const TRUSTED_VIDEO_DOMAINS = [
  'youtube.com',
  'youtu.be',
  'vimeo.com',
  'soundcloud.com',
  'snd.sc',
  'twitch.tv',
  'dailymotion.com',
  'dai.ly',
  'facebook.com',
  'fb.watch',
  'streamable.com',
];

/**
 * Validates if a URL is from a trusted video domain
 * @param url - The URL to validate
 * @returns true if the URL is from a trusted domain, false otherwise
 */
export const isVideoUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();

    const cleanHostname = hostname.replace(/^www\./, '');

    return TRUSTED_VIDEO_DOMAINS.some(domain => cleanHostname === domain);
  } catch {
    return false;
  }
};
